/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Notifications.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-400.js"
import React from 'react'
import useIsBefore from 'Logic/useIsBefore.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  borderBottomLeftRadius: 25,
borderBottomRightRadius: 25,
borderTopLeftRadius: 25,
borderTopRightRadius: 25,
paddingBottom: 4,
paddingLeft: 14,
paddingRight: 40,
paddingTop: 4,
marginRight: 4,
marginBottom: 4,
  
transition: 'opacity 50ms ease-out',
willChange: 'opacity',
  backgroundColor: 'var(--backgroundColor)',
opacity: 'var(--opacity)'})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
alignItems: "center"})
styles.Text = css({label: 'Text',
  fontSize: 25,
marginTop: 4})
styles.Text1 = css({label: 'Text1',
  color: "#ffffff",
lineHeight: 1.3,
fontFamily: "WonderUnitSans",
fontSize: 14,
fontWeight: 400,
marginLeft: 8})

export default function Notifications({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isError,
isOk,
message= ""
}) {
    let isBefore = useIsBefore()
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Notifications.Vertical"
 data-view-path={dataViewPath}
 style={{'--opacity': isBefore ? 0 : 1,'--backgroundColor': isError ? "rgba(224,51,51, 0.75)" : isOk ? "rgba(0,173,87, 0.75)" : "#00a2ff"}}
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="Notifications.Horizontal"
 data-view-path={dataViewPath}
 className={`views-block ${styles.Horizontal}`}
>
<span
 data-testid="Notifications.Text"
 data-view-path={dataViewPath}
 className={`views-text ${styles.Text}`}
>
{isError ? "😬" : "🤩"}
</span>
<span
 data-testid="Notifications.Text:1"
 data-view-path={dataViewPath}
 className={`views-text ${styles.Text1}`}
>
{message}
</span>
</div>
</div>
{children}
</React.Fragment>)
}